export default __webpack_public_path__ + "static/media/O-098.c4849a18.png";